<template>
  <DetailTemplate
    :custom-class="'invoice-detail detail-page'"
    v-if="getPermission('invoice:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0">
          <!-- <Status :status="customerActivated"></Status> -->
          <template v-if="dbInvoice && dbInvoice.status">
            <CustomStatus
              :status="dbInvoice.status"
              endpoint="invoice/status"
            ></CustomStatus>
          </template>
          <v-chip
            label
            color="#a3150b"
            text-color="white"
            class="font-weight-600 font-10"
            v-if="dbInvoice?.is_bad_debt == 1"
          >
            Bad Debt
          </v-chip>
          <!--   <v-chip
              v-if="dbInvoice?.visit_relation?.id"
              label
              color="orange"
              text-color="white"
              class="ml-2 text-uppercase font-weight-600"
              >Converted to Visit</v-chip
            > -->
        </div>
        <div class="mt-5 px-0">
          <table width="100%">
            <!-- Invoice Information -->
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 color-custom-blue text-uppercase py-2 px-3 mb-2 text-left"
              >
                Invoice Information
              </th>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Invoice #
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <div class="d-flex align-center">
                  <v-chip
                    label
                    color="chip-custom-blue"
                    outlined
                    class="text-white px-3 font-weight-600"
                    small
                  >
                    {{ dbInvoice.barcode }}
                  </v-chip>

                  <v-tooltip
                    v-if="dbInvoice?.recurring_count > 0"
                    top
                    content-class="custom-top-tooltip"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-bind="attrs"
                        v-on="on"
                        small
                        label
                        outlined
                        color="chip-custom-blue"
                        class="ml-2 font-weight-600"
                      >
                        <span class="red--text">
                          {{ dbInvoice?.recurring_cycles }}
                        </span>
                        <span class="mx-1">/</span>
                        <span class="green--text">
                          {{ dbInvoice?.recurring_count }}
                        </span>
                      </v-chip>
                    </template>

                    <span>No of Recurring / Total Schedule</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>

            <!-- Visit -->
            <tr v-if="dbInvoice?.visit_relation?.id">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Visit #
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <v-chip
                  label
                  color="cyan"
                  outlined
                  class="text-white font-weight-600"
                  small
                  @click.prevent.stop="routeToVisit()"
                >
                  {{ dbInvoice?.visit_relation?.barcode }}
                </v-chip>
              </td>
            </tr>

            <!-- Enquiry -->
            <tr v-if="dbInvoice?.enquiry_relation?.id">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Enquiry #
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <Barcode
                  dense
                  small
                  :barcode="dbInvoice?.enquiry_relation?.barcode"
                  :id="dbInvoice?.enquiry_relation?.id"
                  :route="'enquiry_relation.detail'"
                />
              </td>
            </tr>

            <!-- Quotation -->
            <tr
              v-if="
                dbInvoice &&
                dbInvoice.quotation_relation &&
                dbInvoice?.quotation_relation?.barcode
              "
            >
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Quotation #
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <Barcode
                  dense
                  small
                  :barcode="dbInvoice?.quotation_relation?.barcode"
                  :id="dbInvoice?.quotation_relation?.id"
                  :route="'quotation.detail'"
                />
              </td>
            </tr>

            <!-- Milestone -->
            <tr v-if="dbInvoice?.milestone_relation?.barcode">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Milestone #
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <Barcode
                  dense
                  small
                  :barcode="dbInvoice?.milestone_relation?.barcode"
                />
              </td>
            </tr>

            <!-- Reference -->
            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Reference #
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed text-capitalize"
              >
                <template v-if="dbInvoice?.customer_ref">
                  {{ dbInvoice?.customer_ref }}
                </template>

                <em v-else class="text-muted"> no reference </em>
              </td>
            </tr>

            <!-- Payment Due -->
            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Payment due
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <template v-if="dbInvoice?.payment_due_text">
                  {{ dbInvoice?.payment_due_text ?? "-" }}
                </template>

                <em v-else class="text-muted"> no Payment due </em>
              </td>
            </tr>

            <!-- Amounts -->
            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Payable Amount
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed orange--text font-weight-600"
              >
                <v-icon small color="orange" class="mr-1"> mdi-cash </v-icon>
                {{ formatMoney(dbInvoice?.total) }}
              </td>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Paid Amount
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed green--text font-weight-600"
              >
                <v-icon small color="green" class="mr-1">
                  mdi-check-circle-outline
                </v-icon>
                {{ formatMoney(dbInvoice?.paid_amount) }}
              </td>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Credit Note Amount
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed blue--text font-weight-600"
              >
                {{ formatMoney(dbInvoice?.credit_note_amount) }}
              </td>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Balance Amount
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed red--text font-weight-600"
              >
                <v-icon small color="red" class="mr-1">
                  mdi-alert-circle-outline
                </v-icon>
                {{ formatMoney(dbInvoice?.pending_amount) }}
              </td>
            </tr>

            <!-- Schedule -->
            <tr v-if="dbInvoice.recurring_message">
              <td
                valign="top"
                width="160"
                class="py-1 font-size-18 font-weight-500"
              >
                Schedule
              </td>

              <td valign="middle" class="py-1 font-size-18">
                <v-icon small color="primary" class="mr-1">
                  mdi-calendar-sync
                </v-icon>
                {{ dbInvoice.recurring_message }}
              </td>
            </tr>

            <!-- Invoice Dates -->
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 color-custom-blue text-uppercase py-2 px-3 mt-4 mb-2 text-left"
              >
                Invoice Dates
              </th>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Invoice Date
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <template v-if="dbInvoice?.date">
                  <v-icon small color="primary" class="mr-1">
                    mdi-calendar
                  </v-icon>
                  {{ formatDate(dbInvoice?.date) ?? "-" }}
                </template>

                <em v-else class="text-muted"> no Invoice Date </em>
              </td>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Invoice Due Date
              </td>

              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed red--text"
              >
                <template v-if="dbInvoice?.due_date">
                  <v-icon small color="red" class="mr-1">
                    mdi-calendar-alert
                  </v-icon>
                  {{ formatDate(dbInvoice?.due_date) ?? "-" }}
                </template>

                <em v-else class="text-muted"> no Invoice Due Date </em>
              </td>
            </tr>

            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500"
              >
                Invoice Sent Date
              </td>

              <td valign="middle" class="py-1 font-size-18 orange--text">
                <template v-if="dbInvoice?.sent_date">
                  <v-icon small color="orange" class="mr-1">
                    mdi-send-outline
                  </v-icon>
                  {{ formatDate(dbInvoice?.sent_date) ?? "-" }}
                </template>

                <em v-else class="text-muted"> no Sent Date </em>
              </td>
            </tr>

            <!-- Cancelled Remark -->
            <tr v-if="dbInvoice?.cancel_remark">
              <th
                colspan="2"
                class="grey lighten-4 color-custom-blue text-uppercase py-2 px-3 mt-4 mb-2 text-left"
              >
                <v-icon small color="error" class="mr-2">
                  mdi-alert-outline
                </v-icon>
                Cancelled Remark
              </th>
            </tr>

            <tr v-if="dbInvoice?.cancel_remark">
              <td colspan="2" valign="middle" class="py-1 font-size-18">
                {{ dbInvoice?.cancel_remark }}
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-5 px-0" v-if="false">
          <table width="100%">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Invoice Information
              </th>
            </tr>
            <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Invoice #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <div class="d-flex">
                  <v-chip
                    label
                    color="chip-custom-blue"
                    outlined
                    class="text-white p-3"
                    small
                    >{{ dbInvoice.barcode }}
                  </v-chip>

                  <v-tooltip
                    v-if="dbInvoice?.recurring_count > 0"
                    top
                    content-class="custom-top-tooltip"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="font-weight-600 custom-blue-border text-uppercase justify-center my-0 font-10 ml-1"
                        color="chip-custom-blue"
                        label
                        outlined
                      >
                        <span style="color: red">{{
                          dbInvoice?.recurring_cycles
                        }}</span>
                        /
                        <span style="color: green">{{
                          dbInvoice?.recurring_count
                        }}</span>
                      </v-chip>
                    </template>
                    <span>No of Recurring / Total Schedule</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <!-- <tr>
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Type
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <v-chip
                  small
                  class="font-weight-600 custom-blue-border text-capitalize justify-center my-0 font-10"
                  color="chip-custom-blue"
                  label
                  outlined
                >
                  {{
                    dbInvoice?.billing_type
                      ? dbInvoice.billing_type.replaceAll("-", " ")
                      : ""
                  }}
                </v-chip>
              </td>
            </tr> -->
            <tr v-if="dbInvoice?.visit_relation?.id">
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Visit #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <v-chip
                  label
                  color="cyan"
                  outlined
                  class="text-white"
                  v-on:click.prevent.stop="routeToVisit()"
                  small
                  >{{ dbInvoice?.visit_relation?.barcode }}
                </v-chip>
              </td>
            </tr>
            <tr v-if="dbInvoice?.enquiry_relation?.id">
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Enquiry #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <Barcode
                  dense
                  small
                  :barcode="dbInvoice?.enquiry_relation?.barcode"
                  :id="dbInvoice?.enquiry_relation?.id"
                  :route="'enquiry_relation.detail'"
                ></Barcode>
              </td>
            </tr>
            <tr
              v-if="
                dbInvoice &&
                dbInvoice.quotation_relation &&
                dbInvoice?.quotation_relation?.barcode
              "
            >
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Quotation #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <Barcode
                  dense
                  small
                  :barcode="dbInvoice?.quotation_relation?.barcode"
                  :id="dbInvoice?.quotation_relation?.id"
                  :route="'quotation.detail'"
                ></Barcode>
              </td>
            </tr>
            <tr v-if="dbInvoice?.milestone_relation?.barcode">
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500"
                width="130"
              >
                Milestone #
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <Barcode
                  dense
                  small
                  :barcode="dbInvoice?.milestone_relation?.barcode"
                ></Barcode>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Reference #
              </td>
              <td valign="middle" class="py-1 font-size-18 text-capitalize">
                <template v-if="dbInvoice?.customer_ref">{{
                  dbInvoice?.customer_ref
                }}</template>
                <em class="text-muted" v-else>no reference</em>
              </td>
            </tr>

            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Payment due
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <template v-if="dbInvoice?.payment_due_text">
                  {{ dbInvoice?.payment_due_text ?? "-" }}</template
                >
                <em class="text-muted" v-else>no Payment due</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Payable Amount
              </td>
              <td valign="middle" class="py-1 font-size-18 orange--text">
                {{ formatMoney(dbInvoice?.total) }}
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Paid Amount
              </td>
              <td valign="middle" class="py-1 font-size-18 green--text">
                {{ formatMoney(dbInvoice?.paid_amount) }}
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Credit Note Amount
              </td>
              <td valign="middle" class="py-1 font-size-18 blue--text">
                {{ formatMoney(dbInvoice?.credit_note_amount) }}
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Balance Amount
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0 red--text">
                  {{ formatMoney(dbInvoice?.pending_amount) }}</label
                >
              </td>
            </tr>
            <tr v-if="dbInvoice.recurring_message">
              <td valign="top" class="py-1 font-size-18 font-weight-500">
                Schedule
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">{{ dbInvoice.recurring_message }}</label>
              </td>
            </tr>

            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Invoice Dates
              </th>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Invoice Date
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <template v-if="dbInvoice?.date"
                  ><label class="m-0" v-if="dbInvoice?.date">
                    {{ formatDate(dbInvoice?.date) ?? "-" }}</label
                  ></template
                >
                <em v-else class="text-muted"> no Invoice Date</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Invoice Due Date
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <template v-if="dbInvoice?.due_date">
                  <label class="m-0 red--text" v-if="dbInvoice?.due_date">
                    {{ formatDate(dbInvoice?.due_date) ?? "-" }}</label
                  ></template
                >
                <em v-else class="text-muted">no Invoice Due Date</em>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Invoice Sent Date
              </td>
              <td valign="middle" class="py-1 font-size-18 orange--text">
                <template v-if="dbInvoice?.sent_date">
                  <label class="m-0 orange--text" v-if="dbInvoice?.sent_date">
                    {{ formatDate(dbInvoice?.sent_date) ?? "-" }}</label
                  ></template
                >
                <em v-else class="text-muted">no Sent Date</em>
              </td>
            </tr>
            <tr v-if="dbInvoice?.cancel_remark">
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Cancelled Remark
              </th>
            </tr>
            <tr v-if="dbInvoice?.cancel_remark">
              <td colspan="2" valign="middle" class="py-1 font-size-18">
                {{ dbInvoice?.cancel_remark }}
              </td>
            </tr>
            <!--  <tr v-if="dbInvoice?.bad_debt_remark">
              <th
                colspan="2"
                class="grey lighten-4 font-size-19 color-custom-blue py-1"
              >
                Bad Debt Remark
              </th>
            </tr>
            <tr v-if="dbInvoice?.bad_debt_remark">
              <td colspan="2" valign="middle" class="py-1 font-size-18">
                {{ dbInvoice?.bad_debt_remark }}
              </td>
            </tr> -->
          </table>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <h1
        v-if="pageLoaded"
        class="form-title custom-nowrap-ellipsis text-capitalize mr-2 font-weight-700"
      >
        {{ dbInvoice.title }}
      </h1>
    </template>
    <template v-slot:header-action>
      <div class="d-flex align-center justify-end" v-if="pageLoaded">
        <template
          v-if="
            dbInvoice.status != 3 &&
            dbInvoice.status != 5 &&
            dbInvoice.recurring_batch
          "
        >
          <v-tooltip bottom content-class="custom-bottom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="invoiceLoading"
                class="mx-2 custom-bold-button white--text"
                color="red"
                v-bind="attrs"
                v-on="on"
                v-on:click="updateMoreAction('cancel-series')"
              >
                <v-icon left>mdi-cancel</v-icon> Cancel Series
              </v-btn>
            </template>
            <span>Cancel Series</span>
          </v-tooltip>
        </template>
        <template
          v-if="
            (dbInvoice.status == 4 || dbInvoice.status == 2) &&
            dbInvoice.pending_amount
          "
        >
          <v-tooltip bottom content-class="custom-bottom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="invoiceLoading"
                class="mx-2 custom-bold-button white--text"
                color="cyan"
                v-bind="attrs"
                v-on="on"
                v-on:click="updateMoreAction('payment')"
              >
                <v-icon left>mdi-currency-usd</v-icon> Payment
              </v-btn>
            </template>
            <span>Click here to add Payment</span>
          </v-tooltip>
        </template>
        <template
          v-if="
            (dbInvoice.status == 4 || dbInvoice.status == 2) &&
            dbInvoice.pending_amount
          "
        >
          <v-tooltip bottom content-class="custom-bottom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="invoiceLoading"
                class="mx-2 custom-bold-button white--text"
                color="cyan"
                v-bind="attrs"
                v-on="on"
                v-on:click="updateMoreAction('credit-note')"
              >
                <v-icon left>mdi-currency-usd</v-icon> Credit Note
              </v-btn>
            </template>
            <span>Click here to add Credit Note</span>
          </v-tooltip>
        </template>
        <v-btn
          v-if="dbInvoice?.status == 1 || dbInvoice?.status == 4"
          v-on:click="updateMoreAction('edit')"
          depressed
          color="cyan white--text"
          class="custom-bold-button"
          ><v-icon small left>mdi-pencil</v-icon>Edit</v-btn
        >
        <template
          v-if="dbInvoice?.more_actions && dbInvoice?.more_actions?.length"
        >
          <template>
            <v-menu
              v-if="dbInvoice?.more_actions && dbInvoice?.more_actions?.length"
              transition="slide-y-transition"
              bottom
              content-class="custom-menu-list"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  depressed
                  color="cyan white--text"
                  class="custom-bold-button mx-2"
                  >More... <v-icon small right>mdi-chevron-down</v-icon></v-btn
                >
              </template>
              <v-list>
                <template v-for="(more, index) in dbInvoice?.more_actions">
                  <v-list-item
                    link
                    v-on:click="updateMoreAction(more.action)"
                    :key="index"
                    :disabled="more.disabled"
                  >
                    <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                      <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="font-weight-500 font-size-14">{{
                      more.title
                    }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
          <!--  <template v-else>
                <v-btn
                  v-for="(more, index) in dbInvoice?.more_actions"
                  v-on:click="updateMoreAction(more.action)"
                  :key="index"
                  :disabled="more.disabled"
                  depressed
                  color="cyan white--text"
                  class="custom-bold-button mx-2"
                  ><v-icon small left>{{ more.icon }}</v-icon>
                  {{ more.title }}</v-btn
                >
              </template> -->
        </template>
        <v-btn v-on:click="goBack()" depressed class="custom-bold-button"
          ><v-icon small left>mdi-chevron-left</v-icon>Back</v-btn
        >
      </div>
    </template>
    <template v-slot:body>
      <!--  <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll quotation-detail-height"
          style="position: relative"
        > -->
      <v-container class="px-0" fluid v-if="pageLoaded">
        <!--  <v-row v-if="pageLoaded">
              <v-col md="12"> -->
        <v-tabs
          active-class="custom-tab-active"
          v-model="invoiceTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent tab-sticky"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#overview">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/property.svg')" />
              <!--end::Svg Icon-->
            </span>
            Overview
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#line-item">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/line-item.svg')" />
              <!--end::Svg Icon-->
            </span>
            Line Items
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#payment">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/invoice.svg')" />
              <!--end::Svg Icon-->
            </span>
            Payments
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#credit-notes">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/invoice.svg')" />
            </span>
            Credit Notes
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#visit">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/visit.svg')" />
              <!--end::Svg Icon-->
            </span>
            Visits
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#attachment">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
              <!--end::Svg Icon-->
            </span>
            Invoice Attachments
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#contract-attachment"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
            </span>
            Contract Attachments
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#quotation-attachment"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
            </span>
            Quotation Attachments
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
              <!--end::Svg Icon-->
            </span>
            History
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="invoiceTab">
          <v-tab-item value="overview">
            <v-container class="px-0" fluid>
              <!-- Location Detail Card -->
              <v-card
                outlined
                elevation="0"
                class="mb-4 invoice-location-card"
              >
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="blue darken-2" small class="mr-2"
                      >mdi-map-marker-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Location Detail
                    </h3>
                  </div>
                </div>
                <v-card-text class="pa-4 font-size-16">
                  <!-- Customer Info Header Banner -->
                  <span
                    class="color-custom-blue font-weight-700 font-size-18 d-block mb-3"
                  >
                    <router-link
                      :to="
                        getDefaultRoute('customer.detail', {
                          params: {
                            id: dbInvoice?.customer_relation?.id,
                          },
                        })
                      "
                      class="color-custom-blue font-size-15 text-decoration-none d-inline-flex align-center invoice-location-customer"
                    >
                      <span class="invoice-location-break">
                        {{ dbInvoice?.customer_relation?.display_name }}
                      </span>
                      <v-icon small color="blue darken-2" class="ml-1"
                        >mdi-open-in-new</v-icon
                      >
                    </router-link>
                  </span>

                  <!-- Segregated Data Sets Grid -->
                  <v-layout class="my-2 invoice-location-grid">
                    <!-- Site Location -->
                    <v-flex
                      md4
                      class="custom-border-right pr-4 invoice-location-column"
                    >
                      <table class="invoice-location-table">
                        <tr>
                          <td
                            class="font-weight-700 color-custom-blue pb-1 font-size-18 text-uppercase"
                          >
                            <v-icon small color="cyan darken-2" class="mr-1"
                              >mdi-map-marker-outline</v-icon
                            >
                            Site Location
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0 font-size-18 font-weight-500">
                            <template>
                              <div
                                class="custom-flex-d align-center mb-1"
                                v-if="
                                  dbInvoice?.property_relation?.property_name
                                "
                              >
                                <v-icon small color="primary" class="mr-1"
                                  >mdi-home-map-marker</v-icon
                                >
                                <span class="font-weight-600">{{
                                  dbInvoice?.property_relation?.property_name
                                }}</span>
                              </div>
                              <div v-else class="mb-1">
                                <em class="text-muted">
                                  <v-icon small class="mr-1"
                                    >mdi-home-map-marker</v-icon
                                  >
                                  no Site Name</em
                                >
                              </div>
                            </template>

                            <template>
                              <div
                                v-if="
                                  dbInvoice?.property_relation?.property_address
                                "
                                class="custom-flex-d"
                              >
                                <v-icon
                                  small
                                  color="cyan darken-3"
                                  class="mr-1 mt-0"
                                  >mdi-map-marker</v-icon
                                >
                                <span>
                                  <template
                                    v-if="dbInvoice?.property_relation?.unit_no"
                                    >{{
                                      dbInvoice?.property_relation?.unit_no
                                    }},</template
                                  >
                                  <template
                                    v-if="
                                      dbInvoice?.property_relation?.street_1
                                    "
                                    >{{
                                      dbInvoice?.property_relation?.street_1
                                    }},</template
                                  >
                                  {{ dbInvoice?.property_relation?.street_2 }}
                                  <br />
                                  {{ dbInvoice?.property_relation?.country }}
                                  <template
                                    v-if="
                                      dbInvoice?.property_relation?.zip_code &&
                                      dbInvoice?.property_relation?.zip_code !=
                                        '000000'
                                    "
                                  >
                                    {{ dbInvoice?.property_relation?.zip_code }}
                                  </template>
                                </span>
                              </div>
                              <div v-else>
                                <em class="text-muted">
                                  <v-icon small class="mr-1"
                                    >mdi-map-marker</v-icon
                                  >
                                  no site location</em
                                >
                              </div>
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="font-weight-700 color-custom-blue pt-3 pb-1 font-size-18 text-uppercase"
                          >
                            <v-icon small color="primary" class="mr-1"
                              >mdi-card-account-phone-outline</v-icon
                            >
                            Contact details
                          </td>
                        </tr>
                        <tr
                          v-if="dbInvoice?.property_contact_person_relation?.id"
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              dbInvoice?.property_contact_person_relation
                                ?.display_name
                            }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            dbInvoice?.property_contact_person_relation
                              ?.primary_phone
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              dbInvoice?.property_contact_person_relation
                                ?.primary_phone
                            }}
                          </td>
                        </tr>
                        <tr
                          v-else-if="
                            !dbInvoice?.property_contact_person_relation?.id
                          "
                          class="py-0 font-size-18 font-weight-500"
                        >
                          <em class="text-muted ml-2"> no phone number</em>
                        </tr>
                        <tr
                          v-if="
                            dbInvoice?.property_contact_person_relation
                              ?.primary_email
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              dbInvoice?.property_contact_person_relation
                                ?.primary_email
                            }}
                          </td>
                        </tr>
                        <tr
                          v-else-if="
                            !dbInvoice?.property_contact_person_relation?.id
                          "
                          class="py-0 font-size-18 font-weight-500"
                        >
                          <em class="text-muted ml-2"> no email address</em>
                        </tr>
                      </table>
                    </v-flex>

                    <!-- Billing Address -->
                    <v-flex
                      md4
                      class="custom-border-right px-4 invoice-location-column"
                    >
                      <table class="invoice-location-table">
                        <tr>
                          <td
                            class="font-weight-700 color-custom-blue pb-1 font-size-18 text-uppercase"
                          >
                            <v-icon small color="blue darken-2" class="mr-1"
                              >mdi-map-marker-radius-outline</v-icon
                            >
                            Billing Address
                          </td>
                        </tr>
                        <tr>
                          <td class="py-0 font-size-18 font-weight-500">
                            <template>
                              <div
                                class="custom-flex-d align-center mb-1"
                                v-if="
                                  dbInvoice?.billing_relation?.property_name
                                "
                              >
                                <v-icon small color="primary" class="mr-1"
                                  >mdi-home-map-marker</v-icon
                                >
                                <span class="font-weight-600">{{
                                  dbInvoice?.billing_relation?.property_name
                                }}</span>
                              </div>
                              <div v-else class="mb-1">
                                <em class="text-muted">
                                  <v-icon small class="mr-1"
                                    >mdi-home-map-marker</v-icon
                                  >
                                  no Site Name</em
                                >
                              </div>
                            </template>

                            <template>
                              <div
                                class="custom-flex-d"
                                v-if="
                                  dbInvoice?.property_relation?.property_address
                                "
                              >
                                <v-icon
                                  small
                                  color="cyan darken-3"
                                  class="mr-1 mt-0"
                                  >mdi-map-marker</v-icon
                                >
                                <span>
                                  <template
                                    v-if="dbInvoice?.billing_relation?.unit_no"
                                    >{{
                                      dbInvoice?.billing_relation?.unit_no
                                    }},</template
                                  >
                                  <template
                                    v-if="dbInvoice?.billing_relation?.street_1"
                                    >{{
                                      dbInvoice?.billing_relation?.street_1
                                    }},</template
                                  >
                                  {{ dbInvoice?.billing_relation?.street_2 }}
                                  <br />
                                  {{ dbInvoice?.billing_relation?.country }}
                                  <template
                                    v-if="
                                      dbInvoice?.billing_relation?.zip_code &&
                                      dbInvoice?.billing_relation?.zip_code !=
                                        '000000'
                                    "
                                  >
                                    {{ dbInvoice?.billing_relation?.zip_code }}
                                  </template>
                                </span>
                              </div>
                              <div v-else>
                                <em class="text-muted">
                                  <v-icon small class="mr-1"
                                    >mdi-map-marker</v-icon
                                  >
                                  no site location</em
                                >
                              </div>
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="font-weight-700 color-custom-blue pt-3 pb-1 font-size-18 text-uppercase"
                          >
                            <v-icon small color="primary" class="mr-1"
                              >mdi-card-account-phone-outline</v-icon
                            >
                            Contact details
                          </td>
                        </tr>
                        <tr
                          v-if="dbInvoice?.billing_contact_person_relation?.id"
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              dbInvoice?.billing_contact_person_relation
                                ?.display_name
                            }}
                          </td>
                        </tr>

                        <tr
                          v-if="
                            dbInvoice?.billing_contact_person_relation
                              ?.primary_phone
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              dbInvoice?.billing_contact_person_relation
                                ?.primary_phone
                            }}
                          </td>
                        </tr>
                        <tr
                          v-else-if="
                            !dbInvoice?.billing_contact_person_relation?.id
                          "
                          class="py-0 font-size-18 font-weight-500"
                        >
                          <em class="text-muted ml-2"> no phone number</em>
                        </tr>
                        <tr
                          v-if="
                            dbInvoice?.billing_contact_person_relation
                              ?.primary_email
                          "
                        >
                          <td class="py-0 font-size-18 font-weight-500">
                            {{
                              dbInvoice?.billing_contact_person_relation
                                ?.primary_email
                            }}
                          </td>
                        </tr>
                        <tr
                          v-else-if="
                            !dbInvoice?.billing_contact_person_relation?.id
                          "
                          class="py-0 font-size-18 font-weight-500"
                        >
                          <em class="text-muted ml-2"> no email address</em>
                        </tr>
                      </table>
                    </v-flex>

                    <!-- Linked Details -->
                    <v-flex md4 class="pl-4 invoice-location-column">
                      <table class="invoice-location-table">
                        <tr>
                          <td
                            class="font-weight-700 color-custom-blue pb-1 font-size-18 text-uppercase"
                          >
                            <v-icon small color="indigo darken-2" class="mr-1"
                              >mdi-link-variant</v-icon
                            >
                            Linked Details
                          </td>
                        </tr>
                        <tbody
                          v-for="source in linkedDetailSources"
                          :key="source.type"
                          class="linked-detail-group"
                          :class="`linked-detail-${source.type}`"
                          :data-linked-detail-type="source.type"
                          @dragover="dragOverLinkedDetail(source.type, $event)"
                          @drop="dropLinkedDetail(source.type, $event)"
                        >
                        <tr
                          class="linked-detail-drag-row"
                          draggable="true"
                          @dragstart="dragLinkedDetail(source.type, $event)"
                          @dragend="endDragLinkedDetail"
                        >
                          <td
                            class="font-weight-700 color-custom-blue pt-2 pb-1 font-size-18 text-uppercase"
                          >
                            <v-icon  class="linked-detail-drag-handle mr-1">mdi-drag</v-icon>
                            <v-icon v-if="source.type === 'quotation'" small color="teal darken-2" class="mr-1">mdi-file-document-outline</v-icon>
                            <v-icon v-else-if="source.type === 'contract'" small color="indigo darken-2" class="mr-1">mdi-file-certificate-outline</v-icon>
                            <v-icon v-else small color="orange darken-2" class="mr-1">mdi-calendar-check-outline</v-icon>
                            {{ source.label }}
                          </td>
                        </tr>
                        <tr v-if="source.type === 'quotation' && linkedQuotations && linkedQuotations.length">
                          <td class="py-0 font-size-18 font-weight-500">
                            <div
                              v-for="(
                                item, index
                              ) in linkedQuotations"
                              :key="index"
                              class="mb-2"
                            >
                              <Barcode
                                dense
                                small
                                :barcode="item?.barcode"
                                :id="item?.id"
                                :route="'quotation.detail'"
                              />
                              {{ item?.job_title }}
                            </div>
                          </td>
                        </tr>

                        <tr v-if="source.type === 'quotation' && (!linkedQuotations || !linkedQuotations.length)">
                          <td class="pb-2">
                            <em class="text-muted">No quotation found</em>
                          </td>
                        </tr>
                        <tr v-if="source.type === 'contract' && linkedContracts && linkedContracts.length">
                          <td class="py-0 font-size-18 font-weight-500">
                            <div
                              v-for="(
                                item, index
                              ) in linkedContracts"
                              :key="index"
                              class="mb-2"
                            >
                              <Barcode
                                dense
                                small
                                :barcode="item?.barcode"
                                :id="item?.id"
                                :route="'contract.detail'"
                              />
                              {{ item.job_title }}
                            </div>
                          </td>
                        </tr>

                        <tr v-if="source.type === 'contract' && (!linkedContracts || !linkedContracts.length)">
                          <td class="pb-2">
                            <em class="text-muted">No contract found</em>
                          </td>
                        </tr>
                        <tr v-if="source.type === 'visit' && dbInvoice?.visits_relation?.length">
                          <td class="py-0 font-size-18 font-weight-500">
                            <div
                              v-for="(item, index) in dbInvoice.visits_relation"
                              :key="index"
                              class="mb-2"
                            >
                              <Barcode
                                dense
                                small
                                :barcode="item?.barcode"
                                :id="item?.id"
                                :route="'visit.detail'"
                              />
                              {{ item.title }}
                            </div>
                          </td>
                        </tr>

                        <tr v-if="source.type === 'visit' && (!dbInvoice?.visits_relation || !dbInvoice.visits_relation.length)">
                          <td>
                            <em class="text-muted">No visit found</em>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <!-- Description Card -->
              <v-card outlined elevation="0" class="mb-4">
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="orange darken-2" small class="mr-2"
                      >mdi-text-box-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Description
                    </h3>
                  </div>
                </div>
                <v-card-text class="pa-4 font-size-16">
                  <read-more
                    class="custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="dbInvoice?.description || '<em>No Description</em>'"
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-card-text>
              </v-card>

              <!-- Internal Notes Card -->
              <v-card outlined elevation="0" class="mb-4">
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="cyan darken-2" small class="mr-2"
                      >mdi-note-text-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Internal Notes
                    </h3>
                  </div>
                </div>
                <v-card-text class="pa-4 font-size-16">
                  <v-row>
                    <v-col cols="12" md="6" class="border-right">
                      <div
                        class="font-weight-700 color-custom-blue font-size-16 mb-2"
                      >
                        Internal Note
                      </div>
                      <read-more
                        class="custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                        more-str="read more"
                        :text="
                          dbInvoice?.admin_note || '<em> No Internal Note</em>'
                        "
                        link="#"
                        less-str="read less"
                        :max-chars="200"
                      >
                      </read-more>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div
                        class="font-weight-700 color-custom-blue font-size-16 mb-2"
                      >
                        Client Note
                      </div>
                      <read-more
                        class="custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                        more-str="read more"
                        :text="
                          dbInvoice?.client_note || '<em> No Client Note</em>'
                        "
                        link="#"
                        less-str="read less"
                        :max-chars="200"
                      >
                      </read-more>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Terms & Conditions Card -->
              <v-card outlined elevation="0" class="mb-4">
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="teal darken-2" small class="mr-2"
                      >mdi-file-document-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Terms &amp; Conditions
                    </h3>
                  </div>
                </div>
                <v-card-text class="pa-4 font-size-16">
                  <read-more
                    class="custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="
                      dbInvoice?.term_conditions ||
                      '<em>No Terms &amp; Conditions</em>'
                    "
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-card-text>
              </v-card>

              <!-- Payment Terms Card -->
              <v-card outlined elevation="0" class="mb-4">
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="indigo darken-2" small class="mr-2"
                      >mdi-credit-card-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Payment Terms
                    </h3>
                  </div>
                </div>
                <v-card-text class="pa-4 font-size-16">
                  <read-more
                    class="custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="
                      dbInvoice?.payment_terms ||
                      '<em>No Terms &amp; Conditions</em>'
                    "
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-card-text>
              </v-card>
            </v-container>
          </v-tab-item>
          <v-tab-item value="line-item">
            <line-item-view
              :show-price="dbInvoice.show_price"
              :discount-level="
                dbInvoice.discount_type == 2 ? 'line_item' : 'transaction'
              "
              :related-id="invoiceId"
              :related-type="2"
              is-invoice
            />
            <div class="mt-4 pr-2 font-weight-600">
              <table width="100%">
                <tr>
                  <td width="70%"></td>
                  <td width="15%">Sub Total</td>
                  <td width="15%" align="right">
                    {{ formatMoney(dbInvoice.sub_total) }}
                  </td>
                </tr>
                <tr v-if="dbInvoice.discount_type == 1">
                  <td></td>
                  <td>
                    Discount
                    <span v-if="dbInvoice.discount_value_type == 1"
                      >({{ formatMoney(dbInvoice.discount_value) }})</span
                    >
                    <span v-if="dbInvoice.discount_value_type == 2"
                      >({{ formatNumber(dbInvoice.discount_value) }}%)</span
                    >
                  </td>
                  <td align="right">
                    {{ formatMoney(dbInvoice.discount_amount) }}
                  </td>
                </tr>
                <tr v-if="dbInvoice.tax_applied">
                  <td></td>
                  <td>Tax [GST {{ dbInvoice.tax_value }}%]</td>
                  <td align="right">
                    {{ formatMoney(dbInvoice.tax_amount) }}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>Adjustment</td>
                  <td align="right">
                    {{ formatMoney(dbInvoice.adjustment) }}
                  </td>
                </tr>
                <tr class="font-size-19">
                  <td></td>
                  <td>Grand Total</td>
                  <td align="right">{{ formatMoney(dbInvoice.total) }}</td>
                </tr>
              </table>
            </div>
          </v-tab-item>
          <v-tab-item value="payment">
            <InternalPayment
              ref="internalPayment"
              :type-id="dbInvoice?.id"
              v-on:edit="editPayment"
              v-on:success="handlePaymentCreated"
            ></InternalPayment>
          </v-tab-item>
          <v-tab-item value="credit-notes">
            <InternalPaymentCredit
              ref="internalPaymentCredit"
              :type-id="dbInvoice?.id"
            ></InternalPaymentCredit>
          </v-tab-item>
          <v-tab-item value="visit"
            >'
            <VisitInternalAll
              :detail="dbInvoice"
              type="invoice"
              :invoice-id="invoiceId"
              :customer-id="
                dbInvoice &&
                dbInvoice.customer_relation &&
                dbInvoice.customer_relation.id
                  ? dbInvoice.customer_relation.id
                  : 0
              "
            ></VisitInternalAll
            >'
          </v-tab-item>

          <v-tab-item :value="'attachment'">
            <AdditionalDocuments
              :type-id="dbInvoice?.id"
              class="mx-0 mb-3"
              type-text="Invoice Attachments"
              :type="3"
              :extensive="false"
              :show-append-to-pdf="true"
              :allow-reorder="true"
            ></AdditionalDocuments>
          </v-tab-item>

          <v-tab-item :value="'contract-attachment'">
            <v-container class="px-0 py-0" fluid>
              <template v-if="linkedContracts && linkedContracts.length">
                <v-progress-linear
                  v-if="isContractsAttachmentLoading && !hasAnyContractAttachments"
                  indeterminate
                  color="cyan"
                  class="my-4"
                ></v-progress-linear>

                <div
                  v-if="hasAnyContractAttachments && linkedContracts.filter(c => contractAttachmentsCount[c.id] > 0).length > 1"
                  class="d-flex justify-end mb-2"
                >
                  <v-btn
                    text
                    small
                    color="indigo darken-2"
                    class="font-weight-600 text-capitalize"
                    @click="toggleAllContracts()"
                  >
                    <v-icon small left>{{ isAllContractsCollapsed() ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                    {{ isAllContractsCollapsed() ? 'Expand All' : 'Collapse All' }}
                  </v-btn>
                </div>

                <v-card
                  v-for="(contract, cIndex) in linkedContracts"
                  :key="'contract-attachment-' + contract.id + '-' + cIndex"
                  v-show="contractAttachmentsCount[contract.id] > 0"
                  outlined
                  elevation="0"
                  class="mb-4"
                >
                  <div
                    class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom cursor-pointer hover-header"
                    @click="toggleContractCollapse(contract.id)"
                  >
                    <div class="d-flex align-center flex-wrap">
                      <v-icon color="indigo darken-2" small class="mr-2"
                        >mdi-file-certificate-outline</v-icon
                      >
                      <h3
                        class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                      >
                        Contract:
                      </h3>
                      <Barcode
                        class="ml-2"
                        dense
                        small
                        :barcode="contract?.barcode"
                        :id="contract?.id"
                        :route="'contract.detail'"
                        @click.native.stop
                      />
                      <span
                        v-if="contract?.job_title"
                        class="ml-2 font-weight-600 color-custom-blue font-size-15"
                      >
                        - {{ contract.job_title }}
                      </span>
                      <v-chip
                        v-if="contractAttachmentsCount[contract.id] > 0"
                        small
                        color="indigo lighten-5"
                        text-color="indigo darken-3"
                        class="ml-3 font-weight-600 px-2"
                        style="height: 22px !important; font-size: 11px !important;"
                      >
                        {{ contractAttachmentsCount[contract.id] }}
                        {{ contractAttachmentsCount[contract.id] === 1 ? 'file' : 'files' }}
                      </v-chip>
                    </div>
                    <div class="d-flex align-center">
                      <v-btn
                        icon
                        small
                        color="indigo darken-2"
                        @click.stop="toggleContractCollapse(contract.id)"
                        :title="contractCollapsed[contract.id] ? 'Expand section' : 'Collapse section'"
                      >
                        <v-icon>{{ contractCollapsed[contract.id] ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <v-expand-transition>
                    <v-card-text v-show="!contractCollapsed[contract.id]" class="pa-0">
                      <AdditionalDocuments
                        :type-id="contract.id"
                        class="mx-0"
                        :type="22"
                        :extensive="false"
                        :allow-reorder="true"
                        :hide-attach="true"
                        :hide-title="true"
                        v-on:files="updateContractFiles(contract.id, $event)"
                      />
                    </v-card-text>
                  </v-expand-transition>
                </v-card>

                <v-card
                  v-if="!isContractsAttachmentLoading && !hasAnyContractAttachments"
                  outlined
                  elevation="0"
                  class="pa-6 text-center my-4"
                >
                  <em class="text-muted font-size-16">
                    No attachments found for linked contracts.
                  </em>
                </v-card>
              </template>
              <template v-else>
                <v-card outlined elevation="0" class="pa-6 text-center my-4">
                  <em class="text-muted font-size-16">
                    No linked contracts found for this invoice.
                  </em>
                </v-card>
              </template>
            </v-container>
          </v-tab-item>

          <v-tab-item :value="'quotation-attachment'">
            <v-container class="px-0 py-0" fluid>
              <template v-if="linkedQuotations && linkedQuotations.length">
                <v-progress-linear
                  v-if="isQuotationsAttachmentLoading && !hasAnyQuotationAttachments"
                  indeterminate
                  color="cyan"
                  class="my-4"
                ></v-progress-linear>

                <div
                  v-if="hasAnyQuotationAttachments && linkedQuotations.filter(q => quotationAttachmentsCount[q.id] > 0).length > 1"
                  class="d-flex justify-end mb-2"
                >
                  <v-btn
                    text
                    small
                    color="teal darken-2"
                    class="font-weight-600 text-capitalize"
                    @click="toggleAllQuotations()"
                  >
                    <v-icon small left>{{ isAllQuotationsCollapsed() ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                    {{ isAllQuotationsCollapsed() ? 'Expand All' : 'Collapse All' }}
                  </v-btn>
                </div>

                <v-card
                  v-for="(quotation, qIndex) in linkedQuotations"
                  :key="'quotation-attachment-' + quotation.id + '-' + qIndex"
                  v-show="quotationAttachmentsCount[quotation.id] > 0"
                  outlined
                  elevation="0"
                  class="mb-4"
                >
                  <div
                    class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom cursor-pointer hover-header"
                    @click="toggleQuotationCollapse(quotation.id)"
                  >
                    <div class="d-flex align-center flex-wrap">
                      <v-icon color="teal darken-2" small class="mr-2"
                        >mdi-file-document-outline</v-icon
                      >
                      <h3
                        class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                      >
                        Quotation:
                      </h3>
                      <Barcode
                        class="ml-2"
                        dense
                        small
                        :barcode="quotation?.barcode"
                        :id="quotation?.id"
                        :route="'quotation.detail'"
                        @click.native.stop
                      />
                      <span
                        v-if="quotation?.job_title"
                        class="ml-2 font-weight-600 color-custom-blue font-size-15"
                      >
                        - {{ quotation.job_title }}
                      </span>
                      <v-chip
                        v-if="quotationAttachmentsCount[quotation.id] > 0"
                        small
                        color="teal lighten-5"
                        text-color="teal darken-3"
                        class="ml-3 font-weight-600 px-2"
                        style="height: 22px !important; font-size: 11px !important;"
                      >
                        {{ quotationAttachmentsCount[quotation.id] }}
                        {{ quotationAttachmentsCount[quotation.id] === 1 ? 'file' : 'files' }}
                      </v-chip>
                    </div>
                    <div class="d-flex align-center">
                      <v-btn
                        icon
                        small
                        color="teal darken-2"
                        @click.stop="toggleQuotationCollapse(quotation.id)"
                        :title="quotationCollapsed[quotation.id] ? 'Expand section' : 'Collapse section'"
                      >
                        <v-icon>{{ quotationCollapsed[quotation.id] ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <v-expand-transition>
                    <v-card-text v-show="!quotationCollapsed[quotation.id]" class="pa-0">
                      <AdditionalDocuments
                        :type-id="quotation.id"
                        class="mx-0"
                        :type="2"
                        :extensive="false"
                        :allow-reorder="true"
                        :hide-attach="true"
                        :hide-title="true"
                        v-on:files="updateQuotationFiles(quotation.id, $event)"
                      />
                    </v-card-text>
                  </v-expand-transition>
                </v-card>

                <v-card
                  v-if="!isQuotationsAttachmentLoading && !hasAnyQuotationAttachments"
                  outlined
                  elevation="0"
                  class="pa-6 text-center my-4"
                >
                  <em class="text-muted font-size-16">
                    No attachments found for linked quotations.
                  </em>
                </v-card>
              </template>
              <template v-else>
                <v-card outlined elevation="0" class="pa-6 text-center my-4">
                  <em class="text-muted font-size-16">
                    No linked quotations found for this invoice.
                  </em>
                </v-card>
              </template>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <internal-history-detail type="invoice" :type_id="dbInvoice?.id" />
          </v-tab-item>
        </v-tabs-items>
        <!-- </v-col>
            </v-row> -->
      </v-container>
      <!--  </perfect-scrollbar> -->
      <confirm-dialog
        key="confirm-dialog-invoice"
        :common-dialog="confirmDialog"
        :dialog-width="dialogWidth"
      >
        <template v-slot:title> Confirmation </template>
        <template v-slot:body>
          <v-container class="px-10" fluid>
            <v-form
              ref="invoiceStausForm"
              v-model.trim="formValid"
              lazy-validation
              v-on:submit.stop.prevent="confirmSubmit()"
            >
              <p
                class="font-weight-600 font-size-19"
                v-if="confirmType != 'mark_as_send'"
              >
                Are you sure, you want to
                <span class="font-weight-700">{{ getConfirmTitle() }}</span
                >?
              </p>
              <p v-else class="font-weight-600 font-size-19">
                Are you sure you have
                <span class="font-weight-700"
                  >send out the invoice..... already to customer</span
                >?
              </p>
              <v-layout
                class="my-4"
                v-if="
                  confirmType == 'mark_as_approved' ||
                  confirmType == 'mark_as_rejected' ||
                  confirmType == 'mark_as_accepted' ||
                  confirmType == 'mark_as_cancelled' ||
                  confirmType == 'mark_as_bad_debt' ||
                  confirmType == 'cancel-series'
                "
              >
                <v-flex>
                  <label class="font-weight-500 font-size-16 required"
                    >Remark</label
                  >
                  <TextAreaField
                    auto-grow
                    dense
                    filled
                    color="cyan"
                    v-model="actionData.remark"
                    :rules="[
                      validateRules.required(actionData.remark, 'Remark'),
                    ]"
                    placeholder="Remark"
                    solo
                    flat
                    row-height="25"
                    counter="150"
                  />
                </v-flex>
              </v-layout>
              <v-layout class="mt-4" v-if="confirmType == 'mark_as_accepted'">
                <v-flex md12>
                  <label class="font-weight-500 font-size-16"
                    >Attachments (Max 5)</label
                  >
                  <table width="100%">
                    <tbody>
                      <tr
                        v-for="(row, index) in actionData.attachments"
                        :key="index"
                      >
                        <td width="50%" class="pl-0 pr-2 py-2">
                          <v-file-input
                            prepend-inner-icon="mdi-attachment mdi-rotate-90"
                            placeholder="Click here to select file"
                            label="Click here to select file"
                            prepend-icon=""
                            color="cyan"
                            solo
                            flat
                            v-model="row.accepted_file"
                            dense
                            v-on:change="updateFileName(index)"
                            hide-details
                          ></v-file-input>
                        </td>
                        <td width="50%" class="pr-0 pl-2 py-2">
                          <v-text-field
                            placeholder="File Name"
                            label="File Name"
                            dense
                            solo
                            flat
                            color="cyan"
                            v-model="row.file_name"
                            hide-details
                            class="has-delete-outer-icon"
                            append-outer-icon="mdi-delete"
                            v-on:click:append-outer="removeRow(index)"
                            :suffix="getFileExtension(row.file_type)"
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr v-if="actionData.attachments?.length < 5">
                        <td colspan="2" class="pl-0">
                          <v-btn
                            color="cyan white--text"
                            small
                            v-on:click="addAttachmentRow()"
                            class="custom-bold-button"
                            >Add More...</v-btn
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="confirmLoading"
            v-on:click="confirmDialog = false"
            class="mx-2 custom-grey-border custom-bold-button"
          >
            No! Close
          </v-btn>
          <v-btn
            depressed
            v-on:click="confirmSubmit()"
            :disabled="confirmLoading || !formValid"
            :loading="confirmLoading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
          >
            Yes! Continue
          </v-btn>
        </template>
      </confirm-dialog>
      <send-mail
        :mail-dialog="mailDialog"
        title="Send as Email"
        type="invoice"
        v-on:close="mailDialog = false"
        :type-id="invoiceId"
        v-on:success="getInvoice()"
      ></send-mail>
      <CreatePaymentTemplate
        v-if="paymentDialog"
        :detail="dbInvoice"
        :payment="selectedPayment"
        :payment-dialog="paymentDialog"
        v-on:close="closePaymentDialog"
        v-on:success="handlePaymentCreated"
      ></CreatePaymentTemplate>
      <CreatePaymentCreditNoteTemplate
        v-if="paymentCreditNoteDialog"
        :detail="dbInvoice"
        :credit-dialog="paymentCreditNoteDialog"
        v-on:close="paymentCreditNoteDialog = false"
        v-on:success="handleCreditNoteCreated"
      ></CreatePaymentCreditNoteTemplate>
      <DeleteDialog :delete-dialog="deleteInvoiceDialog">
        <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3
            class="font-weight-500 delete-text"
            style="font-size: 20px !important"
          >
            Are you sure you want to delete
            <span class="font-weight-700">{{ dbInvoice?.barcode }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="deleteInvoiceLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteInvoiceDialog = false"
            >No! Cancel</v-btn
          >
          <v-btn
            depressed
            :disabled="deleteInvoiceLoading"
            :loading="deleteInvoiceLoading"
            color="red lighten-1 white--text"
            v-on:click="deleteInvoiceConfirm()"
            class="mx-2 custom-grey-border custom-bold-button"
            >Yes! Delete</v-btn
          >
        </template>
      </DeleteDialog>
    </template>
  </DetailTemplate>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CreatePaymentTemplate from "@/view/pages/invoice/Create-Payment.vue";
import CreatePaymentCreditNoteTemplate from "@/view/pages/invoice/Create-Payment-Credit-Note.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import JwtService from "@/core/services/jwt.service";
import {
  UPLOAD,
  PATCH,
  GET,
  DELETE,
} from "@/core/services/store/request.module";
import {
  SET_VIEW_LINE_ITEM,
  SET_VIEW_CALCULATION,
} from "@/core/services/store/line.item.module";
import LineItemViewV2 from "@/view/components/VisitLineItem.vue";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import Dialog from "@/view/pages/partials/Dialog";
import ObjectPath from "object-path";
import SendMail from "@/view/pages/partials/Send-Mail";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import InternalPayment from "@/view/pages/partials/Internal-Payment.vue";
import InternalPaymentCredit from "@/view/pages/partials/Internal-Payment-Credit.vue";
import DeleteDialog from "@/view/pages/partials/Delete";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import VisitInternalAll from "@/view/pages/partials/Detail/VisitInternalAll.vue";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import Barcode from "@/view/pages/partials/Barcode.vue";

/*import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
  import moment from "moment-timezone";
  
  moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);*/

export default {
  mixins: [CommonMixin, ValidationMixin],
  data() {
    return {
      formLoading: false,
      formValid: true,
      tab: null,
      invoiceTab: "overview",
      deleteInvoiceLoading: false,
      deleteInvoiceDialog: false,
      dbInvoice: {},
      linkedDetailSources: [
        { type: "quotation", label: "Quotation Details", order: 0 },
        { type: "contract", label: "Contract Details", order: 1 },
        { type: "visit", label: "Visit Details", order: 2 },
      ],
      draggedLinkedDetail: null,
      lastLinkedDetailTarget: null,
      invoiceId: 0,
      invoiceLoading: false,
      paymentDialog: false,
      selectedPayment: {},
      paymentCreditNoteDialog: false,
      mailDialog: false,
      pageLoaded: false,
      confirmDialog: false,
      confirmLoading: false,
      confirmType: null,
      deleteInvoiceBarcode: null,
      actionData: {
        remark: null,
        status: null,
        uuid: null,
        attachments: [
          {
            accepted_file: null,
            file_name: null,
            file_type: null,
          },
        ],
      },
      contractAttachmentsCount: {},
      contractAttachmentsLoaded: {},
      contractCollapsed: {},
      quotationAttachmentsCount: {},
      quotationAttachmentsLoaded: {},
      quotationCollapsed: {},
      pageLoading: true,
    };
  },
  methods: {
    dragLinkedDetail(type, event) {
      this.draggedLinkedDetail = type;
      this.lastLinkedDetailTarget = null;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", type);
      event.currentTarget.classList.add("linked-detail-dragging");
    },
    endDragLinkedDetail(event) {
      event.currentTarget.classList.remove("linked-detail-dragging");
      this.draggedLinkedDetail = null;
      this.lastLinkedDetailTarget = null;
    },
    dragOverLinkedDetail(targetType, event) {
      event.preventDefault();
      const sourceType = this.draggedLinkedDetail || event.dataTransfer.getData("text/plain");
      if (!sourceType || sourceType === targetType || this.lastLinkedDetailTarget === targetType) return;
      this.lastLinkedDetailTarget = targetType;
      const sourceIndex = this.linkedDetailSources.findIndex((source) => source.type === sourceType);
      const targetIndex = this.linkedDetailSources.findIndex((source) => source.type === targetType);
      if (sourceIndex < 0 || targetIndex < 0) return;
      const reordered = this.linkedDetailSources.slice();
      const [source] = reordered.splice(sourceIndex, 1);
      reordered.splice(targetIndex, 0, source);
      this.linkedDetailSources = reordered.map((item, index) => ({ ...item, order: index }));
    },
    dropLinkedDetail(targetType, event) {
      event.preventDefault();
      this.dragOverLinkedDetail(targetType, event);
      const pdfSources = this.linkedDetailSources.map((source) => ({
        type: source.type,
        order: source.order,
        show_on_pdf: !this.dbInvoice?.pdf_sources?.length
          || this.dbInvoice.pdf_sources.find((item) => item.type === source.type)?.show_on_pdf !== false,
      }));
      this.$store.dispatch(PATCH, {
        url: `invoice-v1/${this.invoiceId}/pdf-sources/order`,
        data: { pdf_sources: pdfSources },
      })
        .then(() => this.getInvoice())
        .catch((error) => this.logError(error));
    },
    editPayment(payment) {
      this.selectedPayment = payment;
      this.paymentDialog = true;
    },
    closePaymentDialog() {
      this.paymentDialog = false;
      this.selectedPayment = {};
    },
    deleteInvoiceConfirm() {
      this.deleteInvoiceLoading = true;
      this.$store
        .dispatch(DELETE, { url: `invoice/${this.dbInvoice?.id}` })
        .then(() => {
          this.deleteInvoiceDialog = false;
          this.$router.push(this.getDefaultRoute("invoice"));
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.deleteInvoiceLoading = false;
        });
    },
    routeToEnquiry() {
      this.$router.push(
        this.getDefaultRoute("enquiry.detail", {
          params: { id: this.dbInvoice?.enquiry },
        })
      );
    },
    routeToQuotation() {
      this.$router.push(
        this.getDefaultRoute("quotation.detail", {
          params: { id: this.dbInvoice?.quotation },
        })
      );
    },
    routeToVisit() {
      this.$router.push(
        this.getDefaultRoute("visit.detail", {
          params: { id: this.dbInvoice?.visit_relation?.id },
        })
      );
    },
    handlePaymentCreated(success) {
      if (success) {
        this.closePaymentDialog();
        this.getInvoice();
        this.$nextTick(() => {
          this.$refs.internalPayment?.getPayments();
        });
      }
    },
    handleCreditNoteCreated(success) {
      if (success) {
        this.getInvoice();
        this.$nextTick(() => {
          this.$refs.internalPaymentCredit?.getPayments();
        });
      }
    },
    confirmSubmit() {
      /*  const validateStatus = this.$refs.invoiceStausForm.validate();
       */
      const formErrors = this.validateForm(this.$refs.invoiceStausForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }
      /*  if(!validateStatus){
        return false;
      }   */
      switch (this.confirmType) {
        case "mark_as_closed":
          this.updateStatus("mark_as_closed");
          break;
        case "mark_as_cancelled":
          this.updateStatus("mark_as_cancelled");
          break;
        case "mark_as_bad_debt":
          this.updateStatus("mark_as_bad_debt");
          break;
        case "unmark_as_bad_debt":
          this.updateStatus("unmark_as_bad_debt");
          break;
        case "mark_as_pending":
          this.updateStatus("mark_as_pending");
          break;
        case "mark_as_rejected":
          this.updateStatus("mark_as_rejected");
          break;
        case "mark_as_accepted":
          this.updateStatus("mark_as_accepted");
          break;
        case "mark_as_send":
          this.updateStatus("mark_as_send");
          break;
        case "mark_as_approved":
          this.updateStatus("mark_as_approved");
          break;
        case "cancel-series":
          this.updateStatus("cancel-series");
          break;
      }
    },
    uploadFiles() {
      let _this = this;
      return new Promise((resolve, reject) => {
        let formData = new FormData();

        let status = false;

        for (let i = 0; i < _this.actionData.attachments.length; i++) {
          if (_this.actionData.attachments[i].accepted_file) {
            status = true;
            formData.append(
              `files[${i}]`,
              _this.actionData.attachments[i].accepted_file,
              _this.actionData.attachments[i].file_name
            );
          }
        }

        if (!status) {
          resolve([]);
        } else {
          _this.$store
            .dispatch(UPLOAD, { url: "file-manager/upload", data: formData })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    async updateStatus() {
      if (this.confirmLoading) {
        return false;
      }

      this.confirmLoading = true;

      this.actionData.status = this.confirmType;
      this.actionData.uuid = this.dbInvoice?.recurring_batch ?? null;
      this.actionData.attachments = await this.uploadFiles();

      this.$store
        .dispatch(PATCH, {
          url: "invoice/" + this.invoiceId + "/status",
          data: this.actionData,
        })
        .then(() => {
          this.getInvoice();
          this.resetConfirm();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    resetConfirm() {
      this.confirmDialog = false;
      this.confirmType = null;
      this.actionData = {
        remark: null,
        status: null,
        attachments: [
          {
            accepted_file: null,
            file_name: null,
            file_type: null,
          },
        ],
      };
    },
    updateFileName(index) {
      const file = this.actionData.attachments[index].accepted_file;
      if (file) {
        this.actionData.attachments[index].file_name = file.name
          .split(".")
          .slice(0, -1)
          .join(".");
        this.actionData.attachments[index].file_type = file.name
          .split(".")
          .pop();
        this.addAttachmentRow();
      }
    },
    removeRow(index) {
      ObjectPath.del(this.actionData.attachments, index);
      this.$nextTick(() => {
        if (!this.actionData.attachments.length) {
          this.addAttachmentRow();
        }
      });
    },
    addAttachmentRow() {
      if (this.actionData.attachments.length < 5) {
        this.actionData.attachments.push({
          accepted_file: null,
          file_name: null,
          file_type: null,
        });
      }
    },
    getFileExtension(file_type) {
      if (file_type) {
        return `.${file_type}`;
      }
      return null;
    },
    getConfirmTitle() {
      if (this.confirmType == "mark_as_closed") {
        return "Mark as Lost";
      } else if (this.confirmType == "mark_as_cancelled") {
        return "Mark as Cancelled";
      } else if (this.confirmType == "mark_as_pending") {
        return "Mark as Pending";
      } else if (this.confirmType == "mark_as_rejected") {
        return "Mark as Rejected";
      } else if (this.confirmType == "mark_as_accepted") {
        return "Mark as Accepted";
      } else if (this.confirmType == "mark_as_approved") {
        return "Mark as Approved";
      } else if (this.confirmType == "mark_as_bad_debt") {
        return "Mark as Bad Debt";
      } else if (this.confirmType == "unmark_as_bad_debt") {
        return "Unmark as Bad Debt";
      } else if (this.confirmType == "cancel-series") {
        return "Cancel Series";
      }
    },
    updateMoreAction(action) {
      this.resetConfirm();
      switch (action) {
        case "edit":
          this.editInvoice();
          break;
        case "convert_visit":
          this.routeToJob();
          break;
        case "signature_link":
          this.getSignatureLink();
          break;
        case "duplicate":
          this.routeToDuplicate();
          break;
        case "payment":
          this.selectedPayment = {};
          this.paymentDialog = true;
          break;
        case "credit-note":
          this.paymentCreditNoteDialog = true;
          break;
        case "mark_as_closed":
          this.confirmDialog = true;
          this.confirmType = "mark_as_closed";
          break;
        case "mark_as_cancelled":
          this.confirmDialog = true;
          this.confirmType = "mark_as_cancelled";
          break;
        case "cancel-series":
          this.confirmDialog = true;
          this.confirmType = "cancel-series";
          break;
        case "mark_as_bad_debt":
          this.confirmDialog = true;
          this.confirmType = "mark_as_bad_debt";
          break;
        case "unmark_as_bad_debt":
          this.confirmDialog = true;
          this.confirmType = "unmark_as_bad_debt";
          break;
        case "send_as_email":
          this.mailDialog = true;
          break;
        case "mark_as_pending":
          this.confirmDialog = true;
          this.confirmType = "mark_as_pending";
          break;
        case "mark_as_rejected":
          this.confirmDialog = true;
          this.confirmType = "mark_as_rejected";
          break;
        case "mark_as_accepted":
          this.confirmDialog = true;
          this.confirmType = "mark_as_accepted";
          break;
        case "mark_as_approved":
          this.confirmDialog = true;
          this.confirmType = "mark_as_approved";
          break;
        case "mark_as_send":
          this.confirmDialog = true;
          this.confirmType = "mark_as_send";
          break;
        case "mark_as_delete":
          this.deleteInvoiceDialog = true;
          break;
        case "download_pdf":
          this.downloadPDF();
          break;
        case "print":
          this.printPDF();
          break;
      }
    },
    editInvoice() {
      this.$router.push(
        this.getDefaultRoute("invoice.update", {
          query: { invoice: this.invoiceId, edit: this.invoiceId },
        })
      );
    },
    routeToJob() {
      this.$router.push(
        this.getDefaultRoute("job.create", {
          query: { invoice: this.invoiceId },
        })
      );
    },
    routeToDuplicate() {
      this.$router.push(
        this.getDefaultRoute("invoice.create", {
          query: { duplicate: this.invoiceId },
        })
      );
    },
    routeToCustomer() {
      //
    },
    downloadPDF() {
      const token = JwtService.getToken();
      const url = `${this.$apiURL}invoice-v1/${this.invoiceId}/pdf?token=${token}&action=download`;
      window.open(url, "_blank");
    },
    printPDF() {
      const token = JwtService.getToken();
      const url = `${this.$apiURL}invoice-v1/${this.invoiceId}/pdf?token=${token}&action=print`;
      window.open(url, "_blank");
    },
    getInvoice() {
      this.$store
        .dispatch(GET, { url: "invoice-v1/" + this.invoiceId })
        .then(({ data }) => {
          this.dbInvoice = data;
          const savedOrder = Array.isArray(this.dbInvoice?.pdf_sources)
            ? this.dbInvoice.pdf_sources
            : [];
          this.linkedDetailSources = this.linkedDetailSources
            .map((source) => {
              const saved = savedOrder.find((item) => item.type === source.type);
              return { ...source, order: saved ? Number(saved.order) : source.order };
            })
            .sort((a, b) => a.order - b.order)
            .map((source, index) => ({ ...source, order: index }));

          this.$store.dispatch(SET_VIEW_CALCULATION, {
            ctx_discount_label: this.dbInvoice?.ctx_discount_label ?? null,
            ctx_discount_value: this.dbInvoice?.ctx_discount_value ?? 0,
            ctx_discount: this.dbInvoice?.ctx_discount ?? 0,
            ctx_discount_type: this.dbInvoice?.ctx_discount_type ?? 1,
            sub_total: this.dbInvoice?.sub_total ?? 1,
            discount_type: this.dbInvoice?.discount_type ?? 1,
            discount_value: this.dbInvoice?.discount_value ?? 0,
            discount_amount: this.dbInvoice?.discount_amount ?? 0,
            tax_active: this.dbInvoice?.tax_active ?? false,
            tax_value: this.dbInvoice?.tax_value ?? 0,
            tax_amount: this.dbInvoice?.tax_amount ?? 0,
            adjustment: this.dbInvoice?.adjustment ?? 0,
            total: this.dbInvoice?.total ?? 0,
            show_price: true,
            discount_level: this.dbInvoice?.discount_level ?? "transaction",
          });

          this.$store.dispatch(SET_VIEW_LINE_ITEM, data.line_item);
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Invoice", route: "invoice" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
          this.contractAttachmentsCount = {};
          this.contractAttachmentsLoaded = {};
          this.contractCollapsed = {};
          this.quotationAttachmentsCount = {};
          this.quotationAttachmentsLoaded = {};
          this.quotationCollapsed = {};
          this.detail_key = Number(new Date());
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoaded = true;
          this.pageLoading = false;
        });
    },
    toggleContractCollapse(contractId) {
      this.$set(
        this.contractCollapsed,
        contractId,
        !this.contractCollapsed[contractId]
      );
    },
    isAllContractsCollapsed() {
      if (!this.linkedContracts || !this.linkedContracts.length) return false;
      const valid = this.linkedContracts.filter(
        (c) => (this.contractAttachmentsCount[c.id] || 0) > 0
      );
      if (!valid.length) return false;
      return valid.every((c) => this.contractCollapsed[c.id]);
    },
    toggleAllContracts() {
      const willCollapse = !this.isAllContractsCollapsed();
      this.linkedContracts.forEach((c) => {
        this.$set(this.contractCollapsed, c.id, willCollapse);
      });
    },
    toggleQuotationCollapse(quotationId) {
      this.$set(
        this.quotationCollapsed,
        quotationId,
        !this.quotationCollapsed[quotationId]
      );
    },
    isAllQuotationsCollapsed() {
      if (!this.linkedQuotations || !this.linkedQuotations.length) return false;
      const valid = this.linkedQuotations.filter(
        (q) => (this.quotationAttachmentsCount[q.id] || 0) > 0
      );
      if (!valid.length) return false;
      return valid.every((q) => this.quotationCollapsed[q.id]);
    },
    toggleAllQuotations() {
      const willCollapse = !this.isAllQuotationsCollapsed();
      this.linkedQuotations.forEach((q) => {
        this.$set(this.quotationCollapsed, q.id, willCollapse);
      });
    },
    updateContractFiles(contractId, files) {
      this.$set(
        this.contractAttachmentsCount,
        contractId,
        files ? files.length : 0
      );
      this.$set(this.contractAttachmentsLoaded, contractId, true);
    },
    updateQuotationFiles(quotationId, files) {
      this.$set(
        this.quotationAttachmentsCount,
        quotationId,
        files ? files.length : 0
      );
      this.$set(this.quotationAttachmentsLoaded, quotationId, true);
    },
  },
  created() {
    this.invoiceId = this.lodash.toSafeInteger(this.$route.params.id);
    this.invoiceTab = this.$route.query.tab ?? "overview";
  },
  mounted() {
    this.getInvoice();
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 40);
    },
    linkedContracts() {
      const list = [];
      const ids = new Set();
      if (
        this.dbInvoice?.contracts_relation &&
        Array.isArray(this.dbInvoice.contracts_relation)
      ) {
        this.dbInvoice.contracts_relation.forEach((c) => {
          if (c && c.id && !ids.has(c.id)) {
            ids.add(c.id);
            list.push(c);
          }
        });
      }
      return list;
    },
    linkedQuotations() {
      const list = [];
      const ids = new Set();
      if (
        this.dbInvoice?.quotations_relation &&
        Array.isArray(this.dbInvoice.quotations_relation)
      ) {
        this.dbInvoice.quotations_relation.forEach((q) => {
          if (q && q.id && !ids.has(q.id)) {
            ids.add(q.id);
            list.push(q);
          }
        });
      }
      if (
        this.dbInvoice?.quotation_relation &&
        this.dbInvoice.quotation_relation.id
      ) {
        if (!ids.has(this.dbInvoice.quotation_relation.id)) {
          ids.add(this.dbInvoice.quotation_relation.id);
          list.push(this.dbInvoice.quotation_relation);
        }
      }
      return list;
    },
    hasAnyContractAttachments() {
      if (!this.linkedContracts || !this.linkedContracts.length) return false;
      return this.linkedContracts.some(
        (c) => (this.contractAttachmentsCount[c.id] || 0) > 0
      );
    },
    isContractsAttachmentLoading() {
      if (!this.linkedContracts || !this.linkedContracts.length) return false;
      return this.linkedContracts.some(
        (c) => !this.contractAttachmentsLoaded[c.id]
      );
    },
    hasAnyQuotationAttachments() {
      if (!this.linkedQuotations || !this.linkedQuotations.length) return false;
      return this.linkedQuotations.some(
        (q) => (this.quotationAttachmentsCount[q.id] || 0) > 0
      );
    },
    isQuotationsAttachmentLoading() {
      if (!this.linkedQuotations || !this.linkedQuotations.length) return false;
      return this.linkedQuotations.some(
        (q) => !this.quotationAttachmentsLoaded[q.id]
      );
    },
  },
  components: {
    "line-item-view": LineItemViewV2,
    "internal-history-detail": InternalHistoryDetail,
    "confirm-dialog": Dialog,
    "send-mail": SendMail,
    DetailTemplate,
    CustomStatus,
    CreatePaymentTemplate,
    CreatePaymentCreditNoteTemplate,
    InternalPayment,
    InternalPaymentCredit,
    DeleteDialog,
    Barcode,
    VisitInternalAll,
    AdditionalDocuments,
  },
};
</script>

<style scoped>
.invoice-location-card,
.invoice-location-grid,
.invoice-location-column {
  min-width: 0;
  max-width: 100%;
}

.invoice-location-table {
  width: 100%;
  table-layout: fixed;
}

.invoice-location-table td,
.invoice-location-break {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.invoice-location-customer {
  max-width: 100%;
  white-space: normal;
  align-items: flex-start !important;
}

.invoice-location-customer .v-icon {
  flex: 0 0 auto;
}

.linked-detail-drag-row {
  cursor: grab;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.linked-detail-drag-row:active {
  cursor: grabbing;
}

.linked-detail-dragging {
  opacity: 0.65;
  box-shadow: 0 2px 8px rgba(36, 50, 109, 0.2);
}

.linked-detail-drag-handle {
  color: #24326d !important;
  opacity: 0.7;
  vertical-align: middle;
}

.linked-detail-quotation {
  --linked-detail-border: #d9dee5;
}

.linked-detail-contract {
  --linked-detail-border: #d9dee5;
}

.linked-detail-visit {
  --linked-detail-border: #d9dee5;
}

.linked-detail-group > tr > td {
  background: transparent;
  border-left: 1px solid var(--linked-detail-border);
  border-right: 1px solid var(--linked-detail-border);
}

.linked-detail-group > tr:first-child > td {
  border-top: 1px solid var(--linked-detail-border);
}

.linked-detail-group > tr:last-child > td {
  border-bottom: 1px solid var(--linked-detail-border);
}

.linked-detail-group > tr:not(.linked-detail-drag-row) > td {
  padding-top: 2px;
  padding-bottom: 2px;
}
.hover-header {
  transition: background-color 0.15s ease;
}
.hover-header:hover {
  background-color: #f1f5f9 !important;
}
</style>
